import { Box, Text } from '@chakra-ui/react'
import { faArrowDownToArc } from '@fortawesome/pro-regular-svg-icons'
import { ItList } from 'types/graphql'

import BrandButton from 'src/components/widgets/buttons/BrandButton/BrandButton'
import Icon from 'src/components/widgets/Icon/Icon'
import { useCurrentUser } from 'src/lib/hooks/auth/useCurrentUser'
import { BrandColor } from 'src/types'

import { BuyOptions } from '../..'

const DontLoseAccessCard: React.FC<{
  brandColor: BrandColor
  itList: ItList
  locked: boolean
  isPreview: boolean
  buy(options?: BuyOptions): unknown
  buyIsLoading: boolean
}> = ({ brandColor, isPreview, itList, locked, buy, buyIsLoading }) => {
  const { isAuthenticated } = useCurrentUser()
  if (isAuthenticated || locked) return null
  return (
    <Box
      borderRadius={12}
      boxShadow="md"
      p={5}
      mx={{ base: 4, lg: isPreview ? 4 : 24 }}
    >
      <h5 className="thick">Don&apos;t lose access to this ItList!</h5>
      <Text className="body-small" mt={3}>
        This can happen if {itList.creator.firstName} archives or starts
        charging for it. Save it to an account and never lose access.
      </Text>
      <BrandButton
        mt={6}
        w="100%"
        brandColor={brandColor}
        leftIcon={<Icon icon={faArrowDownToArc} />}
        isLoading={buyIsLoading}
        onClick={() => {
          buy({ forceCheckout: true })
        }}
        variant="light"
      >
        Save to an Account
      </BrandButton>
    </Box>
  )
}
export default DontLoseAccessCard
